import React from 'react';
import type { EditRecipe } from '@frame/scoring-types';

const C = {
  teal: '#50B8A8', tealHover: '#3D9E8F', blue: '#5186B0',
  text: '#f8fafc', secondary: '#94a3b8',
  surface: '#1e293b', navySoft: '#2D4A66',
  success: '#059669', muted: '#64748b',
} as const;

interface AIRecipeCardProps {
  recipe: EditRecipe;
  onApply: (recipe: EditRecipe) => void;
  locked: boolean;
}

export function AIRecipeCard({ recipe, onApply, locked }: AIRecipeCardProps) {
  const intensityPct = Math.round(recipe.intensity * 100);
  return (
    <div style={{
      background: C.navySoft, borderRadius: 12, padding: '12px 14px',
      marginBottom: 8, border: `1px solid rgba(80,184,168,0.15)`,
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
        <span style={{ fontSize: 13, fontWeight: 600, color: C.text }}>{recipe.editName}</span>
        <span style={{ fontSize: 11, color: C.teal, fontWeight: 500 }}>{intensityPct}%</span>
      </div>
      <p style={{ fontSize: 12, color: C.secondary, margin: '0 0 8px', lineHeight: 1.4 }}>
        {recipe.description}
      </p>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <div style={{
          flex: 1, height: 4, borderRadius: 2, background: 'rgba(255,255,255,0.1)',
          overflow: 'hidden',
        }}>
          <div style={{
            width: `${intensityPct}%`, height: '100%',
            background: `linear-gradient(90deg, ${C.teal}, ${C.blue})`,
            borderRadius: 2,
          }} />
        </div>
        <button
          onClick={() => !locked && onApply(recipe)}
          disabled={locked}
          style={{
            padding: '5px 14px', borderRadius: 6, border: 'none',
            background: locked ? C.muted : `linear-gradient(135deg, ${C.teal}, ${C.blue})`,
            color: '#fff', fontSize: 12, fontWeight: 600,
            cursor: locked ? 'not-allowed' : 'pointer',
            opacity: locked ? 0.5 : 1,
          }}
        >
          {locked ? 'Premium' : 'Apply'}
        </button>
      </div>
    </div>
  );
}
